
import CardUtil from './CardUtil'
import SVGCard from './SVGCard'

const Results = {

  init: () => { },

  buildDisplay: function () {
    const rows = machine.game.evs.map((ev, i, evs) => Results.ev2row(ev, i, evs))
    $('#evs > tbody').html(rows.join(''))
    $('#evs').show()
  },
  computeEVs: function () {
    machine.game.getEVs()
  },
  hideEVs: function () {
    $('#evs').hide()
  },
  ev2row: function (ev, i, evs) {
    var m, a;
    if (i == 0) {
      m = ['B', 'E', 'S', 'T'].join("<br>")
    } else {
      //  `#${i+1}`
      m = `#${ev.rank_without_ties}<br>TIE`
    };
    const evf = ev.ev.toFixed(3)
    const sdf = ev.sd.toFixed(3)
    return `<tr><td>${m}</td><td >${Results.minihold(ev.holdBitCodeL2R)}</td><td>${evf}</td><td>${sdf}</td></tr>`
  },
  minihold: function (bitCodeL2R) {
    return bitCodeL2R.map(function (h, i) {
      let card = (h == 1) ? machine.game.hand[i] : machine.game.noCard
      // card is like c001
      const rankSuit = CardUtil.rankSuit(card)
      return `<span class="card results-card">
          ${SVGCard.mini.byRankSuit(rankSuit.rank, rankSuit.suit)}
        </span>`
    }).join('');
  }
}

export default Results